import React, { ReactNode } from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
interface SectionProps {
  icon?: ReactNode;
  title: string;
  children: ReactNode;
  mt?: number;
}


const Section: React.FC<SectionProps> = ({ icon = null, title, children, mt = 2 }) => (
  <Box
    component="section"
    sx={{
      mt,
      display: "grid",
      gridTemplateColumns: "28px 1fr",
      columnGap: 1,
      alignItems: "start"
    }}
  >
    <Box
      sx={{
        height: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Typography component="span" aria-hidden>
        {icon}
      </Typography>
    </Box>

    <Box>
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        {title}
      </Typography>
      <Box sx={{ mt: 1 }}>{children}</Box>
    </Box>
  </Box>
);

interface Props {
  next: () => void;
  cancel: () => void;
}

export const IntroPage: React.FC<Props> = React.memo(({ next, cancel }) => (
  <Paper sx={{ p: 2.5, mx: 0, bgcolor: 'background.paper' }} elevation={4}>
    <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
      These Things You Can Expect While Creating a New Year
    </Typography>

    <Section title="Groups, Ledgers & Closing Balances" mt={3}>
      <Typography component="p">All active/inactive Groups and Ledgers will be auto-carried to the new year.</Typography>
      <Typography component="p">Renaming/modification/inactivation in the new year won't affect past years.</Typography>
      <Typography component="p">
        Name changes only apply in the year they’re made and reflect in the next year if re-transferred.
      </Typography>
      <Typography component="p">Closing balances (as of today) are set as opening balances automatically.</Typography>
    </Section>

    <Section icon="🧾" title="Items & Voucher Numbers">
      <Typography component="p">All active/inactive Items are copied to the new year.</Typography>
      <Typography component="p">Item numbers remain unchanged across years.</Typography>
      <Typography component="p">Name changes reflect in the financial year only.</Typography>
    </Section>

    <Section icon="🔁" title="Closing Balance Transfer & Synchronization">
      <Typography component="p">Balances auto-transferred.</Typography>
      <Typography component="p">Re-transfer of Groups, Ledgers, and Items also available.</Typography>
      <Typography component="p" sx={{ fontStyle: 'italic', mt: 1, fontSize: '14px', fontFamily: 'inherit' }}>
        Note: Newly added Ledgers and Groups in the current year will not be affected during re-transfer or synchronization.
      </Typography>
    </Section>

    <Section icon="⚙️" title="GST & Voucher Settings">
      <Typography component="p">GST registration details specific to the new year can be configured.</Typography>
      <Typography component="p">Voucher numbers are reset automatically. To continue the series from the previous year, manually set the first invoice number to match the desired sequence.</Typography>
    </Section>

    <Box
      mt={3}
      display="flex"
      justifyContent={{ xs: 'center', md: 'flex-end' }}
      gap={2}
      flexDirection={{ xs: 'column', sm: 'row' }}
      alignItems="center"
    >
      <Button variant="outlined" onClick={cancel} sx={{ width: { xs: '100%', sm: 200 }, maxWidth: '100%' }}>
        Cancel
      </Button>
      <Button variant="contained" size="large" onClick={next} sx={{ width: { xs: '100%', sm: 170 }, maxWidth: '100%' }}>
        Create New Year
      </Button>
    </Box>
  </Paper>
));
